export class APIError extends Error {
    constructor({ endpoint, method, response, statusCode, }) {
        const title = response && typeof response === "object" && "title" in response
            ? String(response.title)
            : "API Error";
        super(`${method} ${endpoint}: ${title}`);
        this.name = "APIError";
        this.endpoint = endpoint;
        this.method = method;
        this.response = response;
        this.statusCode = statusCode;
        // Maintains proper stack trace in V8 environments
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, APIError);
        }
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            endpoint: this.endpoint,
            method: this.method,
            statusCode: this.statusCode,
            response: this.response,
        };
    }
}
